import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { IFolderRecord, INoteRecord } from "../../lib/types";
import pb from "../../lib/pocketbase";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "../../components/Container";

import ModeSwitch from "../../components/ModeSwitch";
import FolderBreadcrumb from "../../components/studio/notes/FolderBreadcrumb";
import Button from "../../components/form/button";
import { useDebounce } from "usehooks-ts";
import Loading from "../../components/Loading";
import { createSlug } from "../../lib/utils";

export default function PublicFolder() {
    console.log("here");
    const navigate = useNavigate();
    const id = useParams().id;
    const [folderLoading, setFolderLoading] = useState(true);
    const [contentLoading, setContentLoading] = useState(true);
    const isContentLoading = useDebounce(contentLoading, 100);
    const [folder, setFolder] = useState<IFolderRecord>();
    const [folders, setFolders] = useState<IFolderRecord[]>();
    const [notes, setNotes] = useState<INoteRecord[]>();

    async function load() {
        setFolderLoading(true);
        if (!id) {
            //navigate("/404");
            return;
        }
        try {
            const record: IFolderRecord = await pb.collection("folder").getOne(id, {
                expand: "parent"
            });
            setFolder(record);
            setFolderLoading(false);
        } catch (e) {
            navigate("/404");
        }
    }

    async function loadFoldersAndFiles() {
        if (folder === undefined) {
            return;
        }
        setContentLoading(true);
        const f: IFolderRecord[] = await pb.collection("folder").getFullList({
            filter: `parent.id="${folder.id}"`,
            sort: "name",
            expand: "parent"
        });
        setFolders(f);

        const n: INoteRecord[] = await pb.collection("note").getFullList({
            filter: `folder.id="${folder.id}"`,
            sort: "name"
        });
        setNotes(n);

        setContentLoading(false);
    }

    useEffect(() => {
        load();
    }, [id]);

    useEffect(() => {
        loadFoldersAndFiles();
    }, [folder]);
    return (
        <>
            <Helmet>
                <title>ReinVB — Folder — {folder?.name || ""}</title>
            </Helmet>
            <div className="flex justify-end p-4">
                <ModeSwitch className="rounded bg-white px-2 py-2 dark:bg-slate-900" />
            </div>

            <Container variant={"small"} className="my-8 @container md:my-8 lg:my-16">
                {folder && <FolderBreadcrumb folder={folder} isPublic />}
                <div className="mt-8 flex flex-col gap-4">
                    {!contentLoading && folders?.length === 0 && notes?.length === 0 && <div className="text-sm italic text-slate-500 dark:text-slate-600">This folder is empty.</div>}
                    {isContentLoading && (
                        <div className="flex justify-center">
                            <Loading />
                        </div>
                    )}
                    {!isContentLoading &&
                        folders?.map((folder) => (
                            <div className="relative" key={folder.id}>
                                <Link key={folder.id} to={`/folder/${createSlug(folder.name)}/${folder.id}`}>
                                    <Button variant={"ghost"} size={"ghost"} className="flex w-full items-center justify-between rounded-lg bg-slate-100 px-6 py-4 active:scale-95 dark:bg-slate-800">
                                        <div className="flex items-center gap-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-5 w-5">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
                                                />
                                            </svg>
                                            <span className="font-semibold">{folder.name}</span>
                                        </div>
                                    </Button>
                                </Link>
                            </div>
                        ))}
                    {!isContentLoading &&
                        notes?.map((note) => (
                            <div className="relative" key={note.id}>
                                <Link key={note.id} to={`/note/${createSlug(note.name)}/${note.id}`}>
                                    <Button variant={"ghost"} size={"ghost"} className="flex w-full items-center justify-between rounded-lg border px-6 py-4 active:scale-95">
                                        <div className="flex items-center gap-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                                                />
                                            </svg>

                                            <span className="font-semibold">{note.name}</span>
                                        </div>
                                    </Button>
                                </Link>
                            </div>
                        ))}
                </div>
            </Container>
        </>
    );
}
